
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInfoReportIec as ObiInfoReportIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-info-report-iec.js';
 
 
 

 
 export const ObiInfoReportIec = createComponent({
   react: React,
   tagName: 'obi-info-report-iec',
   elementClass: ObiInfoReportIecElement,
   events: {
     
   }
  });
 
 